module.exports = __webpack_public_path__ + "img/form-icon.511f99ea.png";